<template>
  <v-flex
    xs12
    sm8
    md6
    class="main-col"
  >
    <p
      class="gotham-m guide-title"
      transition="scale-transition"
    >UP</p>
    <p class="gotham-m guide-desc">{{ $t('t4') }}</p>
    <v-card class="lbt-card">
      <v-card-media>
        <img
          src="../images/up/kv_up.png"
          style="width:100%;height:100%;"
        >
      </v-card-media>
      <v-card-title
        primary-title
        class="card-content"
        :style="{ marginTop: 0 }"
      >
        <ul id="menu">
          <li @click="$vuetify.goTo('#download')">
            {{ $t('t7') }}
          </li>
          <li @click="$vuetify.goTo('#interface')">
            {{ $t('t8') }}
          </li>
          <li @click="$vuetify.goTo('#poweron_off')">
            {{ $t('t9') }}
          </li>
          <li @click="$vuetify.goTo('#connect')">
            {{ $t('t10') }}
          </li>
          <li @click="$vuetify.goTo('#basic_operation')">
            {{ $t('t11') }}
          </li>
          <li @click="$vuetify.goTo('#auto_power_saving')">
            {{ $t('t12') }}
          </li>
          <li @click="$vuetify.goTo('#status')">
            {{ $t('t13') }}
          </li>
          <li @click="$vuetify.goTo('#faq')">
            {{ $t('t14') }}
          </li>
          <li @click="$vuetify.goTo('#spec')">
            {{ $t('t15') }}
          </li>
        </ul>
      </v-card-title>
    </v-card>
    <!--下载-->
    <v-card
      id="download"
      class="lbt-card"
    >
      <v-card-title
        primary-title
        class="card-content"
      >
        <p class="lbt-card-title">{{ $t('t16')}}</p>
        <p class="lbt-content">{{ $t('t17') }}</p>
        <v-layout
          row
          justify-center
          align-center
        >
          <v-flex xs8>
            <v-layout
              column
              align-center
            >
              <img
                src="../images/up/app_logo.png"
                class="full-pic"
              >
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card-title>
    </v-card>
    <!--按键及接口说明-->
    <v-card
      id="interface"
      class="lbt-card"
    >
      <v-card-title
        primary-title
        class="card-content"
      >
        <p class="lbt-card-title">{{ $t('t18')}}</p>
        <img
          src="../images/up/interface.png"
          class="full-pic"
        />
        <p class="lbt-content">{{ $t('t19') }}</p>
      </v-card-title>
    </v-card>
    <!--开关机-->
    <v-card
      id="poweron_off"
      class="lbt-card"
    >
      <v-card-title
        primary-title
        class="card-content"
      >
        <p class="lbt-card-title">{{ $t('t20')}}</p>
        <img src="../images/up/power_on_off.png" class="full-pic" />
        <p class="lbt-content">{{ $t('t21') }}</p>
        <p class="lbt-content">{{ $t('t22') }}</p>
      </v-card-title>
    </v-card>
    <!--连接-->
    <v-card
      id="connect"
      class="lbt-card"
    >
      <v-card-title
        primary-title
        class="card-content"
      >
        <p class="lbt-card-title">{{ $t('t23')}}</p>
        <p class="lbt-content-flex"><img src="../images/up/connect01.gif" />{{ $t('t24') }}</p>
        <div class="hairline"></div>
        <p class="lbt-content-flex"><img src="../images/up/connect02.png" />{{ $t('t25') }}</p>
        <div class="hairline"></div>
        <p class="lbt-content-flex"><img src="../images/up/connect03.png" />{{ $t('t26') }}</p>
      </v-card-title>
    </v-card>
    <!--基本操作-->
    <v-card
      id="basic_operation"
      class="lbt-card"
    >
      <v-card-title
        primary-title
        class="card-content"
      >
        <p class="lbt-card-title">{{ $t('t27')}}</p>
        <p class="lbt-content-dark">{{ $t('t28') }}</p>
        <img
          src="../images/up/gesture_control.png"
          class="full-pic"
        />
        <p class="lbt-content">{{ $t('t29') }}</p>
        <p class="lbt-content-light">{{ $t('t30') }}</p>
        <div class="hairline"></div>

        <p class="lbt-content-dark">{{ $t('t31') }}</p>
        <img
          src="../images/up/device_switch.png"
          class="full-pic"
        />
        <p class="lbt-content">{{ $t('t32') }}</p>
        
        <div class="hairline"></div>
        <p class="lbt-content-dark">{{ $t('t33') }}</p>
        <img
          src="../images/up/volume_control.png"
          class="full-pic"
        />
        <p class="lbt-content">{{ $t('t34') }}</p>
        <div class="hairline"></div>

        <p class="lbt-content-dark">{{ $t('t35') }}</p>
        <p class="lbt-content">{{ $t('t36') }}</p>
      </v-card-title>
    </v-card>
    <!--自动省电-->
    <v-card
      id="auto_power_saving"
      class="lbt-card"
    >
      <v-card-title
        primary-title
        class="card-content"
      >
        <p class="lbt-card-title">{{ $t('t37') }}</p>
        <img
          src="../images/up/power_save.png"
          class="full-pic"
        />
        <p class="lbt-content">{{ $t('t38') }}</p>
        <p class="lbt-content-light">{{ $t('t39') }}</p>
      </v-card-title>
    </v-card>
    <!--状态指示-->
    <v-card
      id="status"
      class="lbt-card"
    >
      <v-card-title
        primary-title
        class="card-content"
      >
        <p class="lbt-card-title">{{ $t('t40')}}</p>
        <p class="lbt-content-dark">{{ $t('t41') }}</p>

        <div class="lbt-card-table">
          <div class="table-head">
            <div class="row-td-left">{{ $t('t42').split('/')[0] }}</div>
            <div class="row-td-right">{{ $t('t42').split('/')[1] }}</div>
          </div>
          <div class="table-row">
            <div class="row-td-left">{{ $t('t43').split('/')[0] }}</div>
            <div class="row-td-right">{{ $t('t43').split('/')[1] }}</div>
          </div>
          <div class="table-row">
            <div class="row-td-left">{{ $t('t44').split('/')[0] }}</div>
            <div class="row-td-right">{{ $t('t44').split('/')[1] }}</div>
          </div>
          <div class="table-row">
            <div class="row-td-left">{{ $t('t45').split('/')[0] }}</div>
            <div class="row-td-right">{{ $t('t45').split('/')[1] }}</div>
          </div>
          <div class="table-row">
            <div class="row-td-left">{{ $t('t46').split('/')[0] }}</div>
            <div class="row-td-right">{{ $t('t46').split('/')[1] }}</div>
          </div>
        </div>
        <div class="hairline"></div>

        <p class="lbt-content-dark">{{ $t('t47') }}</p>
        <div class="lbt-card-table">
          <div class="table-head">
            <div class="row-td-left">{{ $t('t48').split('/')[0] }}</div>
            <div class="row-td-right">{{ $t('t48').split('/')[1] }}</div>
          </div>
          <div class="table-row">
            <div class="row-td-left">{{ $t('t49').split('/')[0] }}</div>
            <div class="row-td-right">{{ $t('t49').split('/')[1] }}</div>
          </div>
          <div class="table-row">
            <div class="row-td-left">{{ $t('t50').split('/')[0] }}</div>
            <div class="row-td-right">{{ $t('t50').split('/')[1] }}</div>
          </div>
          <div class="table-row">
            <div class="row-td-left">{{ $t('t51').split('/')[0] }}</div>
            <div class="row-td-right">{{ $t('t51').split('/')[1] }}</div>
          </div>
          <div class="table-row">
            <div class="row-td-left">{{ $t('t52').split('/')[0] }}</div>
            <div class="row-td-right">{{ $t('t52').split('/')[1] }}</div>
          </div>
          <div class="table-row">
            <div class="row-td-left">{{ $t('t53').split('/')[0] }}</div>
            <div class="row-td-right">{{ $t('t53').split('/')[1] }}</div>
          </div>
        </div>
      </v-card-title>
    </v-card>
    <!--常见问题-->
    <v-card
      id="faq"
      class="lbt-card"
    >
      <v-card-title
        primary-title
        class="card-content"
      >
        <p class="lbt-card-title">{{ $t('t54')}}</p>
        <p class="lbt-content-dark">{{ $t('t55') }}</p>
        <p class="lbt-content">{{ $t('t56') }}</p>
        <p class="lbt-content-light">{{ $t('t57') }}</p>
        <div class="hairline"></div>
        <p class="lbt-content-dark">{{ $t('t58') }}</p>
        <p class="lbt-content">{{ $t('t59') }}</p>
        <div class="hairline"></div>
        <p class="lbt-content-dark">{{ $t('t60') }}</p>
        <p class="lbt-content">{{ $t('t61') }}</p>
        <p class="lbt-content-light">{{ $t('t62') }}</p>
      </v-card-title>
    </v-card>
    <!--产品参数-->
    <v-card
      id="spec"
      class="lbt-card"
    >
      <v-card-title
        primary-title
        class="card-content"
      >
        <p class="lbt-card-title">{{ $t('t63')}}</p>
        <p class="lbt-content-dark">{{ $t('t64') }}</p>
        <p class="lbt-content">{{ $t('t65') }}</p>
        <p class="lbt-content-dark">{{ $t('t66') }}</p>
        <p class="lbt-content">{{ $t('t67') }}</p>
        <p class="lbt-content-dark">{{ $t('t68') }}</p>
        <p class="lbt-content">{{ $t('t69') }}</p>
        <p class="lbt-content-dark">{{ $t('t70') }}</p>
        <p class="lbt-content">{{ $t('t71') }}</p>
        <p class="lbt-content-dark">{{ $t('t72') }}</p>
        <p class="lbt-content">{{ $t('t73') }}</p>
        <p class="lbt-content-dark">{{ $t('t74') }}</p>
        <p class="lbt-content">{{ $t('t75') }}</p>
        <p class="lbt-content-dark">{{ $t('t76') }}</p>
        <p class="lbt-content">{{ $t('t77') }}</p>
      </v-card-title>
    </v-card>
  </v-flex>
</template>

<script>
export default {
  name: 'Content',
  props: ['lang']
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/up/content.vue